<template>
  <div :class="['pop-container', {open: !!attributes.start}]">
    <div class="pop-box">
      <div class="btn-close"><img @click="closePopUp()" src="~images/project/close.svg" /></div>
      <div class="pop-content" v-if="attributes && attributes.start">
        <div class="current-card popup">
          <img class="attachment" v-if="attributes.attachment" :src="getSource(attributes.attachment)"/>
          <div class="content">
            <h3 :class="['date', attributes.noun.replace(' ', '-'), {future: new Date(attributes.start) > new Date()}]" v-markdown="attributes.daystring"></h3>
            <h4 v-markdown="attributes.title"></h4>
            <p class="party" v-markdown="attributes.party"></p>
            <p class="constituency" v-markdown="attributes.constituency"></p>

            <div class="btns">
              <a class="live-link" v-if= "attributes.noun==='happening now' && attributes['link-live']" :href="attributes['link-live']" target="_blank">Go to live coverage</a>
              <a v-if="new Date(attributes.end) > new Date()" target="_blank" :href="`https://www.google.com/calendar/render?action=TEMPLATE&amp;text=${attributes.title}&amp;dates=${googleDateFormat(attributes.start)}/${googleDateFormat(attributes.end)}&amp;details=${attributes['calendar-desc']}&amp;location=Singapore&amp;sprop=&amp;sprop=name:`">Add to Google Calendar +</a>
            </div>

            <p class="description" v-markdown="attributes.description"></p>

            <div class="list" v-if="attributes.list">
              <h4 class="list-title" v-markdown="attributes['list-title']"></h4>
              <p class="list-name" v-markdown="attributes.list"></p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapState} from 'vuex'

export default {
  // props: ['attributes'],
  computed: {
    ...mapState(['eventpopdata'])
  },
  data () {
    return {
      isOpen: false,
      attributes: {}
    }
  },
  watch: {
    'eventpopdata.start': function (newVal, oldVal) {
      const self = this
      this.attributes = this.eventpopdata
      this.formatList()
      if (!newVal) {
        document.body.style['overflow-y'] = 'auto'
        return
      } else {
        document.body.style['overflow-y'] = 'hidden'
        setTimeout(() => {
          self.isOpen = true
          // resize text-container container based on image width so that there is no extra space
          var img = self.$el.querySelector('img.attachment')

          const onloadFunc = () => {
            setTimeout(() => {
              if (img.width > 280) {
                self.$el.querySelector('.current-card.popup').style.width = img.width + 'px'
              } else {
                self.$el.querySelector('.current-card.popup').style.width = '280px'
              }
            })
          }

          if (img) {
            img.onload = function () {
              onloadFunc()
            }

            if (img.complete) {
              onloadFunc()
            }
          }
        })
      }
    }
  },
  methods: {
    getSource (value) {
      if (value && !value.substring(0, 10).includes('://')) {
        return require(`images/${value}`)
      }
      return value
    },
    googleDateFormat (val) {
      var newVal = val
      var date = new Date(newVal)
      if (!newVal) {
        date = new Date(this.attributes.start)
        date.setHours(23, 59, 59, 999)
      }
      return (date).toISOString().replace(/-|:|\.\d\d\d/g, '')
    },
    closePopUp () {
      this.isOpen = false
      this.$store.commit('pushResponse', {
        eventpopdata: {}
      })
    },
    formatList () {
      var namesList = this.attributes['list-names'] ? this.attributes['list-names'].split(';') : []
      namesList.map((element, i) => element.trim())
      this.attributes.list = namesList.join(', ')
    }
  },
  mounted () {
    const self = this
    $(document).click(function (event) {
      // close pop-up if clicked outside
      const target = $(event.target)
      if (!target.closest('.pop-box').length && self.isOpen) {
        self.closePopUp()
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.pop-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  background-color: rgba(0,0,0,.5);
  opacity: 0;
  z-index: 1;
  transition: opacity 0.5s ease-in-out;
  &.open {
    opacity: 1;
    width: 100vw;
    height: 100vh;
  }
}
.pop-box {
  position: absolute;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FFF;
  /* height: 100%; */
  max-height: 90%;
  overflow: hidden;
  @media (min-height: 750px) {
    max-height: 750px;
  }
  .btn-close {
    text-align: right;
    img {
      cursor: pointer;
      border-radius: 50%;
      margin: 10px 10px 0 0;
      opacity: 0.7;
      transition: opacity .15s ease-out;
      width: 25px;
      &:hover {
        opacity: 1;
      }
    }
  }
  .pop-content {
    overflow-y: auto;
    overflow-x: hidden;
    width: 94vw;
    max-height: 80vh;
    @include breakpoint($d_small) {
      width: 100%;
      max-width: 900px;
    }

    .content {
      padding: 15px;
    }

    h4 {
      font-size: 16px;
      line-height: 1.3em;
    }

    p {
      font-size: 16px;
      font-family: $font-CuratorRegular;
      line-height: 1.3em;
    }

    img {
      max-width: 100%;
      margin: 0 auto;
      display: block;
      max-height: 300px;
    }

    .date {
      padding-bottom: 10px;
      text-transform: uppercase;
      font-family: $font-CuratorRegular;
      font-size: 15px;
      color: rgba(12, 43, 87, 0.2);

      &.future {
        color: rgba(12, 43, 87, 0.5);
      }
      &.happening-now {
        color: #D6445C;
      }
      &.today {
        color: #0C2B57;
      }
    }

    .constituency {
      color: #808080;
    }

    .description {
      padding-top: 10px;
    }

    .btns {
      padding-top: 15px;
      a {
        font-family: $font-CuratorRegular;
        color: #333;
        font-size: 14px;
        border: 1px solid #e6eae9;
        padding: 4px 20px;
        border-radius: 25px;
        margin: 0 7px 10px 0;
        display: inline-block;

        &.live-link {
          background-color: #D6445C;
          border: none;
          color: #FFF;
        }
      }
    }

    .list {
      .list-title {
        padding: 10px 0;
      }
      .list-item {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        padding-bottom: 12px;

        .col {
          display: flex;
          flex-direction: column;
          flex-basis: 100%;
          flex: 1;
        }

        .list-img {
          vertical-align: middle;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          margin-right: 10px;
          flex: 0 0 45px;
        }
        .list-texts {
          .list-name {
            padding-top: 8px;
          }
        }
      }
    }

  }
}
</style>
